<div class="card bg-white relative border-none">
  <div class="card-header p-3 sm:p-5">
    <div class="flex items-center justify-between">
      <p class="flex mb-0 pb-0 text-primaryDark text-lg sm:text-xl font-bold mr-12">
        <span *ngIf="data.mode === 'recipient'" i18n="@@fina-branch-selection.title">Izberite poslovno enoto primatelja</span>
        <span *ngIf="data.mode === 'sender' && data.context === 'settings'" i18n="@@fina-sender-branch-selection.title.settings">Izberite vašo poslovno enoto FINA</span>
        <span *ngIf="data.mode === 'sender' && data.context === 'invoice-creation'" i18n="@@fina-sender-branch-selection.title.invoice">Nastavite poslovno enoto za izdajanje računov</span>
      </p>

      <button (click)="cancel()" class="btn border-transparent shadow-none text-gray hover:text-grayDark fadeInFadeOut" *ngIf="data.mode === 'recipient' || data.context !== 'invoice-creation'">
        <i class="fas fa-times text-lg"></i>
      </button>
    </div>
  </div>

  <div class="card-content pt-0">
    <div class="mb-4">
      <!-- Recipient Info (only for recipient mode) -->
      <p class="text-grayDark text-sm mb-3" *ngIf="data.mode === 'recipient'">
        <strong i18n="@@fina-branch-selection.recipient">Primatelj:</strong> {{ data.recipientName }}<br>
        <strong i18n="@@fina-branch-selection.oib">OIB:</strong> {{ data.recipientOib }}
      </p>

      <!-- Description Card -->
      <div class="card mb-4">
        <div class="card-content flex flex-col text-sm">
          <div class="flex flex-row mb-2">
            <div class="text-lg">
              <i class="text-blue fas fa-info-circle mr-3"></i>
            </div>
            <div class="text-grayDark">
              <!-- Recipient mode description -->
              <span *ngIf="data.mode === 'recipient'" i18n="@@fina-branch-selection.description">
                Ta primatelj ima več registriranih poslovnih enot v FINA sistemu. Prosimo, izberite poslovno enoto, kamor želite poslati e-račun.
              </span>

              <!-- Sender mode - Settings context -->
              <span *ngIf="data.mode === 'sender' && data.context === 'settings'" i18n="@@fina-sender-branch-selection.description.settings">
                Izberite poslovno enoto, ki bo izdajala e-račune. Ta nastavitev se uporabi za vse račune.
              </span>

              <!-- Sender mode - Invoice creation context -->
              <span *ngIf="data.mode === 'sender' && data.context === 'invoice-creation'" i18n="@@fina-sender-branch-selection.description.invoice">
                Pred ustvarjanjem računov prosimo izberite, katera poslovna enota vašega podjetja bo izdajala e-račune. To nastavitev je potrebno opraviti samo enkrat.
              </span>
            </div>
          </div>
        </div>
      </div>

      <p class="text-grayDark text-sm font-semibold mb-2">
        <span *ngIf="data.mode === 'recipient'" i18n="@@fina-branch-selection.select-branch">Izberite poslovno enoto:</span>
        <span *ngIf="data.mode === 'sender'" i18n="@@fina-sender-branch-selection.select-branch">Izberite vašo poslovno enoto:</span>
      </p>

      <div class="space-y-2">
        <div *ngFor="let branch of data.branches"
             (click)="selectBranch(branch)"
             class="card cursor-pointer transition-all duration-200 hover:shadow-md"
             [ngClass]="{'border-2 border-green bg-greenWashed': isSelected(branch), 'border border-grayLight': !isSelected(branch)}">
          <div class="card-content flex items-start">
            <div class="flex-shrink-0 mt-1">
              <i class="fas text-lg mr-3"
                 [ngClass]="isSelected(branch) ? 'fa-check-circle text-green' : 'fa-circle text-grayLight'"></i>
            </div>
            <div class="flex-grow">
              <p class="font-semibold text-base mb-1" [ngClass]="isSelected(branch) ? 'text-green' : 'text-grayDark'">
                {{ branch.party_name }}
              </p>
              <p class="text-sm text-gray mb-0">
                <span class="font-medium" *ngIf="getBranchType(branch.party_id) === 'main'" i18n="@@fina-branch-selection.main-branch">Glavna enota</span>
                <span class="font-medium" *ngIf="getBranchType(branch.party_id) === 'sub'" i18n="@@fina-branch-selection.sub-branch">Podružnica</span>
                <span class="ml-1">•</span>
                <span class="ml-1" *ngIf="getBranchType(branch.party_id) === 'main'">OIB: {{ branch.endpoint_id }}</span>
                <span class="ml-1" *ngIf="getBranchType(branch.party_id) === 'sub'" i18n="@@fina-branch-selection.code">Šifra: {{ getBranchCode(branch.party_id) }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Note about saving preference -->
      <div class="card mt-4" *ngIf="data.mode === 'recipient' && data.preferredBranchPartyId">
        <div class="card-content flex flex-col text-sm">
          <div class="flex flex-row">
            <div class="text-lg">
              <i class="text-orangeDark fas fa-lightbulb mr-3"></i>
            </div>
            <div class="text-grayDark">
              <span i18n="@@fina-branch-selection.remember-preference">
                Vaša izbira bo shranjena in naslednjič samodejno izbrana za tega primatelja.
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Note about changing later (sender + invoice creation) -->
      <div class="card mt-4" *ngIf="data.mode === 'sender' && data.context === 'invoice-creation'">
        <div class="card-content flex flex-col text-sm">
          <div class="flex flex-row">
            <div class="text-lg">
              <i class="text-orangeDark fas fa-lightbulb mr-3"></i>
            </div>
            <div class="text-grayDark">
              <span i18n="@@fina-sender-branch-selection.change-later">
                To nastavitev lahko pozneje spremenite v nastavitvah fiskalizacije.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div class="flex flex-row justify-end">
      <button class="btn btn-grayDark-link mr-1" (click)="cancel()" *ngIf="data.mode === 'recipient' || data.context !== 'invoice-creation'">
        <span i18n="@@fina-branch-selection.cancel">Prekliči</span>
      </button>
      <button class="btn btn-success ml-1"
              [disabled]="!selectedBranch"
              (click)="confirm()">
        <span *ngIf="data.mode === 'recipient'" i18n="@@fina-branch-selection.confirm">Potrdi izbiro</span>
        <span *ngIf="data.mode === 'sender'" i18n="@@fina-sender-branch-selection.confirm">Shrani poslovno enoto</span>
      </button>
    </div>
  </div>
</div>
